import Link from "next/link";
import React from "react";
import styles from "./attend_university.module.scss";

const AttendUniversity = () => {
  return (
    <section className={styles.section_attend_university}>
      <div className="container">
        <div className={styles.header_wrapper}>
          <h2>Meet Attending Universities</h2>
          <p>
            Nulla consequuntur voluptate exercitationem, repudiandae quisquam
            minima voluptatum enim velit natus quam perspiciatis id eos
            necessitatibus dicta.
          </p>
        </div>
        <div className={styles.uni_wrapper}>
          <Link href="#">
            <img
              src="https://www.avila.edu/wp-content/themes/avila/img/logo.svg"
              alt="Avila University - Be Inspired."
            />
          </Link>
          <Link href="#">
            <img
              src="https://d31cuupyjbe4e1.cloudfront.net/ADMIN/Elmhurst-University-Logo-f84f1b0a-d6b1-4f6e-8d6c-6ffc7848d01a.png"
              alt="Elmhurst University"
            />
          </Link>
          <Link href="#">
            <img
              src="https://www.avila.edu/wp-content/themes/avila/img/logo.svg"
              alt="Avila University - Be Inspired."
            />
          </Link>
          <Link href="#">
            <img
              src="https://d31cuupyjbe4e1.cloudfront.net/ADMIN/Elmhurst-University-Logo-f84f1b0a-d6b1-4f6e-8d6c-6ffc7848d01a.png"
              alt="Elmhurst University"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AttendUniversity;
